const allImages = document.querySelectorAll("[data-lasyload]");
import {LazyLoadImages} from "./intersectionObserver";

if(allImages && allImages.length){
    LazyLoadImages(allImages);
}